/**
 * Flask API client for calculations and airport search
 */

// Use relative path for Vercel serverless, falls back to localhost for development
const API_BASE_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5001/api'
);

/**
 * Get all airports for client-side filtering
 */
export async function getAllAirports() {
  const response = await fetch(`${API_BASE_URL}/airports/all`);

  if (!response.ok) {
    throw new Error('Failed to load airports');
  }

  return response.json();
}

/**
 * Search airports by code, name, or city
 */
export async function searchAirports(query, limit = 10) {
  const response = await fetch(
    `${API_BASE_URL}/airports/search?q=${encodeURIComponent(query)}&limit=${limit}`
  );

  if (!response.ok) {
    throw new Error('Failed to search airports');
  }

  return response.json();
}

/**
 * Get airport by IATA code
 */
export async function getAirport(iataCode) {
  const response = await fetch(`${API_BASE_URL}/airports/${iataCode}`);

  if (!response.ok) {
    throw new Error(`Airport ${iataCode} not found`);
  }

  return response.json();
}

/**
 * Calculate flight distance and status points
 */
export async function calculateFlight(origin, destination, fareClass = 'economy', customMultiplier = null) {
  const response = await fetch(`${API_BASE_URL}/calculations/flight`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      origin,
      destination,
      fare_class: fareClass,
      custom_multiplier: customMultiplier,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to calculate flight');
  }

  return response.json();
}

/**
 * Get available fare classes
 */
export async function getFareClasses() {
  const response = await fetch(`${API_BASE_URL}/fare-classes`);

  if (!response.ok) {
    throw new Error('Failed to get fare classes');
  }

  return response.json();
}
